export interface DashboardConfType {
  dashboard_id: string;
  name: string;
  icon_name: string;
  title?: string;
}

export const ICONS_PATH = `/assets/dashboards/`;
